"use strict";

import {
  dashboardConstants,
  commonConstants,
  accountTypesConstants,
} from "../_constants";

const INITIAL_DASHBAORD_DATA_STATE = {
  cbsDown: false,
  isSavingAccountsListLoading: false,
  savingAccountList: {
    list: [],
  },
  isCreditCardListLoading: false,
  creditCardList: {
    list: [],
  },
  isCurrentAccountListLoading: false,
  currentAccountList: {
    list: [],
  },
  isSavingAccountListLoading: false,
  savingAccountOnlyList: {
    list: [],
  },
  bannersList: [],
  loginWebBannersList: [],
  isAccountHistoryListLoading: false,
  accountHistoryList: [],
  transactionCurrencyCode: "",
  isDebitCardListLoading: false,
  debitCardList: {
    list: [],
  },
  secureMailNotification: null,
};

export function dashboard(state = INITIAL_DASHBAORD_DATA_STATE, action) {
  switch (action.type) {
    case dashboardConstants.DASHBOARD_ACCOUNTS_LIST_REQUEST:
      switch (action?.payload?.accountType) {
        case accountTypesConstants.CASA_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: false,
            isSavingAccountsListLoading: true,
            isAccountHistoryListLoading: true,
            savingAccountList: {
              ...state.savingAccountList,
              list: [],
            },
            accountHistoryList: [],
          };
        case accountTypesConstants.CREDIT_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: false,
            isCreditCardListLoading: true,
            creditCardList: {
              ...state.creditCardList,
              list: [],
            },
          };
        case accountTypesConstants.CURRENT_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: false,
            isCurrentAccountListLoading: true,
            currentAccountList: {
              ...state.currentAccountList,
              list: [],
            },
            accountHistoryList: [],
          };
        case accountTypesConstants.SAVING_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: false,
            isSavingAccountListLoading: true,
            savingAccountOnlyList: {
              ...state.savingAccountOnlyList,
              list: [],
            },
            accountHistoryList: [],
          };
        default:
          return state;
      }
    case dashboardConstants.DASHBOARD_ACCOUNTS_LIST_SUCCESS:
      switch (action?.payload?.data?.accountType) {
        case accountTypesConstants.CASA_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: false,
            isSavingAccountsListLoading: false,
            savingAccountList: {
              ...state.savingAccountList,
              list: action.payload.data.accountDetails,
            },
            accountHistoryList: [],
          };
        case accountTypesConstants.CREDIT_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: false,
            isCreditCardListLoading: false,
            creditCardList: {
              ...state.creditCardList,
              list: action.payload.data.creditCardList,
            },
          };
        case accountTypesConstants.DEBIT_CARD_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: false,
            isDebitCardListLoading: false,
            debitCardList: {
              ...state.debitCardList,
              list: action.payload.data.debitCardList,
            },
          };
        case accountTypesConstants.CURRENT_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: false,
            isCurrentAccountListLoading: false,
            currentAccountList: {
              ...state.currentAccountList,
              list: action.payload.data.accountDetails,
            },
          };
        case accountTypesConstants.SAVING_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: false,
            isSavingAccountListLoading: false,
            savingAccountOnlyList: {
              ...state.savingAccountOnlyList,
              list: action.payload.data.accountDetails,
            },
          };
        default:
          return state;
      }

    case dashboardConstants.DASHBOARD_ACCOUNTS_LIST_ERROR:
      switch (action?.payload?.accountType) {
        case accountTypesConstants.CASA_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: true,
            isSavingAccountsListLoading: false,
            savingAccountList: {
              ...state.savingAccountList,
              list: [],
            },
          };
        case accountTypesConstants.CREDIT_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: true,
            isCreditCardListLoading: false,
            creditCardList: {
              ...state.creditCardList,
              list: [],
            },
          };
        case accountTypesConstants.DEBIT_CARD_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: true,
            isDebitCardListLoading: false,
            debitCardList: {
              ...state.debitCardList,
              list: [],
            },
          };
        case accountTypesConstants.CURRENT_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: true,
            isCurrentAccountListLoading: false,
            currentAccountList: {
              ...state.currentAccountList,
              list: [],
            },
          };
        case accountTypesConstants.SAVING_ACCOUNT_TYPE:
          return {
            ...state,
            cbsDown: true,
            isSavingAccountListLoading: false,
            savingAccountOnlyList: {
              ...state.savingAccountOnlyList,
              list: [],
            },
          };
        default:
          return state;
      }

    case dashboardConstants.DASHBOARD_BANNER_LIST_SUCCESS: {
      const requestBannerType =
        action.payload?.bannerType ?? action.payload?.data?.bannerType;
      const bannerSlides = action.payload?.data?.bannerSlides ?? [];

      if (requestBannerType === dashboardConstants.BANNER_TYPE_HOME_BANNER) {
        return {
          ...state,
          bannersList: bannerSlides,
        };
      }

      if (requestBannerType === dashboardConstants.BANNER_TYPE_LOGIN_WEB) {
        return {
          ...state,
          loginWebBannersList: bannerSlides,
        };
      }

      return state;
    }

    case dashboardConstants.DASHBOARD_BANNER_LIST_ERROR:
      return {
        ...state,
        bannersList: [],
        loginWebBannersList: [],
      };

    case dashboardConstants.CLEAR_LOGIN_WEB_BANNERS_LIST:
      return {
        ...state,
        loginWebBannersList: [],
      };

    case dashboardConstants.DASHBOARD_ACCOUNT_HISTORY_LIST_REQUEST:
      return {
        ...state,
        isAccountHistoryListLoading: true,
        accountHistoryList: [],
        transactionCurrencyCode: "",
      };

    case dashboardConstants.DASHBOARD_ACCOUNT_HISTORY_LIST_COMPLETE:
      return {
        ...state,
        isAccountHistoryListLoading: false,
        accountHistoryList: action.payload.data.transactions,
        transactionCurrencyCode: action?.payload?.data?.transactionCurrencyCode,
      };

    case dashboardConstants.DASHBOARD_ACCOUNT_HISTORY_LIST_ERROR:
      return {
        ...state,
        isAccountHistoryListLoading: false,
        accountHistoryList: [],
        transactionCurrencyCode: "",
      };

    case dashboardConstants.DASHBOARD_SECURE_MAIL_NOTIFICATION_SUCCESS:
      return {
        ...state,
        secureMailNotification: action.payload.data.secureMailList,
      };

    case dashboardConstants.DASHBOARD_SECURE_MAIL_NOTIFICATION_ERROR:
      return {
        ...state,
        secureMailNotification: null,
      };

    case dashboardConstants.DASHBOARD_SECURE_MAIL_NOTIFICATION_CLEAR:
      return {
        ...state,
        secureMailNotification: null,
      };
    case dashboardConstants.DASHBOARD_CLEAR_ACCOUNT_HISTORY_LIST:
      return {
        ...state,
        savingAccountList: {
          list: [],
        },
      };
  }

  return state;
}
